export default {};
export function isAdhocMetricSimple(metric) {
    return metric.expressionType === 'SIMPLE';
}
//# sourceMappingURL=Metric.js.map